import React from "react";
import { FC, useEffect } from "react";

import { WidgetEnv } from "@xapp/chat-widget";

export interface ChatSnippetProps {
    readonly widgetKey: string;
    /**
     * If true, it is expected that this is a production environment widget it will not set the environment to staging,
     */
    readonly production?: boolean;
    /**
     * Override the url, otherwise it looks for the environment specific one.
     */
    readonly url?: string;
}

interface WindowWithConfig extends Window {
    xaConfig?: Partial<WidgetEnv>;
}

export const ChatSnippet: FC<ChatSnippetProps> = (props) => {
    const { widgetKey, production, url } = props;

    useEffect(() => {
        if (widgetKey) {
            if (!production) {
                // Make sure we are on the staging environment
                (window as WindowWithConfig).xaConfig = {
                    attributes: {
                        environment: "staging",
                    },
                };
            }

            const script = document.createElement("script");
            const scriptId = `xapp-js`;
            if (!document.getElementById(scriptId)) {
                script.id = scriptId;
                const widgetUrl = url || window.xaStudioConfig?.widgetUrl;
                script.src = `${widgetUrl}/xapp-chat-widget.js?key=${widgetKey}`;
                // script.async = true;
                document.body.appendChild(script);
            }
        }

        return () => {
            // clean out the config modification
            (window as WindowWithConfig).xaConfig = undefined;
        };
    }, [production, url, widgetKey]);

    return <></>;
};
